export default "__VITE_ASSET__Bim6P$yO__"